// @owners { team: patients-team }
import { createQueryKeys } from '@lukemorales/query-key-factory';
import { get } from '~shared/helpers/apiHelper';
import { useQuery } from '~shared/react-query';

export const orderSuccess = createQueryKeys('orderSuccess', {
  // There is a mismatch in the expected param format in FetchOrderSuccessRequest (shipment_ids) and that which is
  // expected in the scriptdash controller (shipmentIDs) /app/controllers/patients/v1/order_success_controller.rb#L13
  // hence params here is defined as { shipmentIDs: number[] }
  fetchOrderSuccess: (params: { shipmentIDs: number[] }) => ({
    queryKey: [params],
    queryFn: async () => {
      return await get('/order_success', params, { version: 'v1' });
    },
  }),
});

export const useFetchOrderSuccess = (shipmentIDs: number[]) => {
  const { isLoading, error, data } = useQuery({
    ...orderSuccess.fetchOrderSuccess({ shipmentIDs }),
    enabled: shipmentIDs.length > 0,
  });

  return {
    isLoading,
    error,
    shipments: data?.data?.shipments,
    firstSelfScheduled: data?.data?.first_self_scheduled,
    totalShipmentsCount: data?.data?.total_shipments_count,
  };
};
